module.exports = __webpack_public_path__ + "e5035a584c13256d508cd2c2b57e35fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/adobe_2021_chart.png
// module id = 1621
// module chunks = 0